export const ModalSizes = {
  xs: 'w-[264px]',
  sm: 'w-full sm:w-[420px]',
  md: 'w-[568px]',
  lg: 'w-[800px]',
  xl: 'w-[960px]',
  fs: 'w-dvw h-dvh',
} as const

export const ModalPlacements = {
  'top': 'top',
  'left': 'left',
  'right': 'right',
  'bottom': 'bottom',
  'center': 'center',
  'top-start': 'top-start',
  'top-end': 'top-end',
  'bottom-start': 'bottom-start',
  'bottom-end': 'bottom-end',
} as const
